export const SOCIAL_PLATFORMS = ['facebook', 'instagram', 'youtube'] as const;

export type SocialPlatform = (typeof SOCIAL_PLATFORMS)[number];

export function isValidSocialHref(href: string | undefined | null): boolean {
    const value = href?.trim();
    return Boolean(value && value !== '#');
}

export function hasSocialLinks(
    socialLinks: Partial<Record<SocialPlatform, unknown>> | undefined | null,
    resolveHref: (raw: unknown) => string | undefined,
): boolean {
    if (!socialLinks) return false;
    return SOCIAL_PLATFORMS.some((key) => isValidSocialHref(resolveHref(socialLinks[key])));
}
